module.exports = __webpack_public_path__ + "img/malaysia.ad4126be.svg";